import Cookies from 'js-cookie';

// Cookie Handling

const cookieBanner = document.querySelector('.cookie-banner');
const cookieBannerClose = cookieBanner.querySelector('button');

function showCookieBar() {
  cookieBanner.classList.add('active');
  localStorage.setItem('__BATBcookies', 'unaccepted');
  Cookies.set('__BATBcookies', 'unaccepted');
}

function closeCookieBar() {
  cookieBanner.classList.remove('active');
  localStorage.setItem('__BATBcookies', 'accepted');
  Cookies.set('__BATBcookies', 'accepted', {expires: 365});
}

if (localStorage.getItem('__BATBcookies') !== 'accepted') {
  setTimeout(showCookieBar, 2000);
}

cookieBannerClose.addEventListener('click', () => {
  closeCookieBar();
});
